import { useEffect, useState } from "react";
import AdminPanel from "./AdminPanel";
import MendesCut from "./MendesCut";
import CancelPage from "./CancelPage";
import { supabase, signInWithGoogle, isAdminSession } from "./supabase";
import { App as CapApp } from "@capacitor/app";
import { Browser } from "@capacitor/browser";

function SplashScreen({ fading }) {
  useEffect(() => {
    const link = document.createElement('link');
    link.href = 'https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Lato:wght@300;400;700&display=swap';
    link.rel = 'stylesheet';
    document.head.appendChild(link);
  }, []);

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 99999, background: '#201E1A',
      display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
      opacity: fading ? 0 : 1, transition: 'opacity 0.4s ease',
      pointerEvents: 'none', // ne bloque jamais les taps sur l'écran en dessous
    }}>
      <style>{`@keyframes splashIn{from{opacity:0;transform:scale(0.92)}to{opacity:1;transform:scale(1)}}`}</style>
      <div style={{ animation: 'splashIn 0.8s cubic-bezier(0.16,1,0.3,1)', textAlign: 'center' }}>
        <div style={{ fontFamily: "'Bebas Neue',sans-serif", fontSize: 46, letterSpacing: '0.12em', color: '#F0EAE0' }}>
          MENDES <span style={{ color: '#C8A96E' }}>✂</span> CUT
        </div>
        <div style={{ width: 48, height: 1, background: '#C8A96E', margin: '10px auto', opacity: 0.6 }} />
        <div style={{ fontFamily: "'Lato',sans-serif", fontSize: 10, letterSpacing: '0.35em', color: '#7A7060', textTransform: 'uppercase' }}>
          Barber Shop
        </div>
      </div>
    </div>
  );
}

function AuthScreen({ onGuest, onPro, t, initialMode = 'main' }) {
  const [mode, setMode] = useState(initialMode); // main | email
  const [authKind, setAuthKind] = useState('login'); // login | signup
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [okMsg, setOkMsg] = useState("");
  const [nom, setNom] = useState("");
  const [email, setEmail] = useState("");
  const [pwd, setPwd] = useState("");

  const inputStyle = {
    width: '100%', boxSizing: 'border-box', background: 'var(--input)', border: '1px solid var(--gold-a35)', borderRadius: 6,
    padding: '13px 14px', color: 'var(--text)', fontFamily: "'Lato',sans-serif", fontSize: 14, outline: 'none',
  };

  async function loginGoogle() {
    setLoading(true); setError("");
    const { error } = await signInWithGoogle();
    if (error) { setError(t.errGoogle); }
    setLoading(false);
  }

  async function submitEmail() {
    setError(""); setOkMsg("");
    if (!email.includes('@') || pwd.length < 6) { setError(t.errFields); return; }
    setLoading(true);
    if (authKind === 'signup') {
      const { data, error } = await supabase.auth.signUp({
        email: email.trim(), password: pwd,
        options: { data: { full_name: nom.trim(), role: 'client' } },
      });
      if (error) setError(t.errSignup);
      else {
        if (nom.trim()) lsSet("client-name", nom.trim());
        if (!data.session) setOkMsg(t.checkEmail); // confirmation email requise
        // si data.session existe, onAuthStateChange dans App fait entrer directement
      }
    } else {
      const { error } = await supabase.auth.signInWithPassword({ email: email.trim(), password: pwd });
      if (error) setError(t.errAuth);
    }
    setLoading(false);
  }

  if (mode === 'email') {
    return (
      <div style={{
        minHeight: '100vh', background: 'var(--bg)', display: 'flex', flexDirection: 'column',
        alignItems: 'center', justifyContent: 'center', padding: '40px 24px',
        fontFamily: "'Lato',sans-serif",
      }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div style={{ fontFamily: "'Bebas Neue',sans-serif", fontSize: 32, letterSpacing: '0.12em', color: 'var(--text)' }}>
            MENDES <span style={{ color: 'var(--gold)' }}>✂</span> CUT
          </div>
          <div style={{ fontSize: 10, letterSpacing: '0.3em', color: 'var(--muted)', textTransform: 'uppercase', marginTop: 6 }}>
            {authKind === 'signup' ? t.signupTitle : t.loginTitle}
          </div>
        </div>

        <div style={{ width: '100%', maxWidth: 340, display: 'flex', flexDirection: 'column', gap: 12 }}>
          {authKind === 'signup' && (
            <input type="text" placeholder={t.nameLbl} value={nom} onChange={(e) => setNom(e.target.value)} style={inputStyle} />
          )}
          <input type="email" placeholder={t.emailLbl} value={email} onChange={(e) => setEmail(e.target.value)} style={inputStyle} autoCapitalize="none" />
          <input
            type="password" placeholder={t.pwdLbl} value={pwd}
            onChange={(e) => setPwd(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && submitEmail()}
            style={inputStyle}
          />

          <button onClick={submitEmail} disabled={loading} style={{
            width: '100%', padding: '15px', background: 'var(--gold)', border: 'none', borderRadius: 6,
            color: 'var(--on-gold)', fontFamily: "'Bebas Neue',sans-serif", fontSize: 16,
            letterSpacing: '0.2em', cursor: 'pointer', opacity: loading ? 0.6 : 1,
          }}>
            {authKind === 'signup' ? t.signupBtn : t.loginBtn}
          </button>

          {error && <div style={{ fontSize: 12, color: 'var(--danger)', textAlign: 'center' }}>{error}</div>}
          {okMsg && <div style={{ fontSize: 12, color: 'var(--ok)', textAlign: 'center', lineHeight: 1.5 }}>{okMsg}</div>}

          <button
            onClick={() => { setAuthKind(authKind === 'signup' ? 'login' : 'signup'); setError(""); setOkMsg(""); }}
            style={{ background: 'none', border: 'none', color: 'var(--gold)', fontSize: 12, cursor: 'pointer', fontFamily: "'Lato',sans-serif", padding: 8 }}
          >
            {authKind === 'signup' ? t.toLogin : t.toSignup}
          </button>
          <button
            onClick={() => { setMode('main'); setError(""); setOkMsg(""); }}
            style={{ background: 'none', border: 'none', color: 'var(--muted)', fontSize: 12, cursor: 'pointer', fontFamily: "'Lato',sans-serif" }}
          >
            {t.backLbl}
          </button>
        </div>
      </div>
    );
  }

  return (
    <div style={{
      minHeight: '100vh', background: 'var(--bg)', display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center', padding: '40px 24px',
      fontFamily: "'Lato',sans-serif",
    }}>
      <div style={{ textAlign: 'center', marginBottom: 56 }}>
        <div style={{ fontFamily: "'Bebas Neue',sans-serif", fontSize: 40, letterSpacing: '0.12em', color: 'var(--text)' }}>
          MENDES <span style={{ color: 'var(--gold)' }}>✂</span> CUT
        </div>
        <div style={{ width: 48, height: 1, background: 'var(--gold)', margin: '10px auto', opacity: 0.6 }} />
        <div style={{ fontSize: 10, letterSpacing: '0.35em', color: 'var(--muted)', textTransform: 'uppercase' }}>
          {t.slogan}
        </div>
      </div>

      <div style={{ width: '100%', maxWidth: 340, display: 'flex', flexDirection: 'column', gap: 14 }}>
        <button onClick={loginGoogle} disabled={loading} style={{
          display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 12,
          width: '100%', padding: '15px', background: 'var(--btnc-bg)', border: '1px solid var(--btnc-border)', borderRadius: 6,
          color: '#201E1A', fontFamily: "'Lato',sans-serif", fontWeight: 700, fontSize: 14,
          cursor: 'pointer', opacity: loading ? 0.6 : 1,
        }}>
          <svg width="18" height="18" viewBox="0 0 48 48">
            <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
            <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
            <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
            <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
          </svg>
          {t.googleLogin}
        </button>

        <button onClick={() => setMode('email')} style={{
          display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10,
          width: '100%', padding: '15px', background: 'transparent',
          border: '1px solid var(--gold-a5)', borderRadius: 6, color: 'var(--text)',
          fontFamily: "'Lato',sans-serif", fontWeight: 700, fontSize: 13, cursor: 'pointer',
        }}>
          ✉️ {t.emailOption}
        </button>

        <div style={{ display: 'flex', alignItems: 'center', gap: 12, margin: '2px 0' }}>
          <div style={{ flex: 1, height: 1, background: 'var(--gold-a2)' }} />
          <div style={{ fontSize: 10, color: 'var(--muted)', textTransform: 'uppercase', letterSpacing: '0.2em' }}>{t.orDivider}</div>
          <div style={{ flex: 1, height: 1, background: 'var(--gold-a2)' }} />
        </div>

        <button onClick={onGuest} style={{
          width: '100%', padding: '15px', background: 'transparent',
          border: '1px solid var(--gold-a5)', borderRadius: 6, color: 'var(--gold)',
          fontFamily: "'Bebas Neue',sans-serif", fontSize: 16, letterSpacing: '0.2em', cursor: 'pointer',
        }}>
          {t.guest}
        </button>

        {error && <div style={{ fontSize: 12, color: 'var(--danger)', textAlign: 'center' }}>{error}</div>}
      </div>

      <button onClick={onPro} style={{
        position: 'absolute', bottom: 'calc(28px + env(safe-area-inset-bottom))', background: 'none', border: 'none',
        color: 'var(--muted)', fontSize: 11, letterSpacing: '0.2em', textTransform: 'uppercase',
        cursor: 'pointer', fontFamily: "'Lato',sans-serif", textDecoration: 'underline',
        textUnderlineOffset: 4, textDecorationColor: 'var(--gold-a2)',
      }}>
        {t.pro}
      </button>
    </div>
  );
}

const MAPS_URL = "https://www.google.com/maps/search/?api=1&query=60+Avenue+de+Vaudagne,+1217+Meyrin";
const INSTA_URL = "https://instagram.com/mendescut.barbershop";
const SHOP_PHONE = "+41791723575";
const GOOGLE_REVIEW_URL = "https://search.google.com/local/writereview?placeid=ChIJSVfQkiJjjEcR8JAPeXJgZSw";

// localStorage peut être indisponible (mode privé, restrictions webview) → jamais bloquant
function lsGet(key) { try { return localStorage.getItem(key); } catch { return null; } }
function lsSet(key, value) { try { localStorage.setItem(key, value); } catch {} }
function lsDel(key) { try { localStorage.removeItem(key); } catch {} }

// Traductions des écrans "coquille" (auth, home, profil, mes RDV).
// Le flow de réservation (MendesCut.jsx) et l'admin restent en FR pour l'instant.
const T = {
  fr: {
    slogan: "Obtiens le style que tu mérites",
    googleLogin: "Connexion avec Google",
    googleLoginShort: "Se connecter avec Google",
    errGoogle: "Connexion Google indisponible pour le moment.",
    guest: "Continuer en invité",
    pro: "Espace pro",
    shopSub: "Barber Shop · Meyrin",
    book: "Réserver", bookSub: "Choisis ton service et ton créneau", bookCta: "Prendre RDV",
    myRdv: "Mes RDV", myRdvSub: "Gérer ma réservation",
    profile: "Profil", profileSub: "Mon compte",
    place: "Lieu", placeSub: "Meyrin, Genève", socials: "Réseaux",
    guestMode: "Mode invité",
    myNumber: "Mon numéro · utilisé pour mes réservations",
    numberSaved: "✓ Numéro enregistré — pré-rempli à chaque réservation",
    nextRdv: "Mon prochain rendez-vous", manageRdv: "Gérer mes rendez-vous",
    visit: "Visite", visits: "Visites",
    usualCut: "Ma coupe habituelle", rebook: "Re-réserver",
    review: "⭐ Laisser un avis", call: "📞 Appeler", wa: "💬 WhatsApp",
    logout: "Déconnexion",
    settings: "Paramètres",
    photoLbl: "Photo de profil", changePhoto: "Changer", removePhoto: "Retirer",
    language: "Langue", themeLbl: "Thème", darkLbl: "Sombre", lightLbl: "Clair",
    bkTitle1: "Mes", bkTitle2: "rendez-vous",
    findSub: "Retrouve tes réservations avec ton numéro",
    loadingTxt: "Chargement…",
    none: "Aucune réservation trouvée pour ce numéro.",
    cancelRdv: "Annuler ce RDV",
    cancelWarn: "⚠️ Annulation au minimum 24h à l'avance. En cas d'absence non signalée, 50% du montant sera facturé.",
    confirm: "Confirmer", keep: "Garder", cancelling: "Annulation…",
    orDivider: "ou",
    emailOption: "Continuer avec email",
    loginTitle: "Connexion", signupTitle: "Créer un compte",
    nameLbl: "Prénom / Nom", emailLbl: "Adresse email", pwdLbl: "Mot de passe (6 caractères min.)",
    loginBtn: "Se connecter", signupBtn: "Créer mon compte",
    toSignup: "Pas encore de compte ? Crée-en un", toLogin: "Déjà un compte ? Connecte-toi",
    checkEmail: "Compte créé ! Vérifie ta boîte mail pour confirmer ton adresse, puis connecte-toi.",
    errAuth: "Email ou mot de passe incorrect.",
    errSignup: "Création du compte impossible. Réessaie.",
    errFields: "Entre un email valide et un mot de passe de 6 caractères minimum.",
    backLbl: "← Retour",
    orEmailProfile: "ou créer un compte avec email",
    noUpcoming: "Aucun rendez-vous à venir",
    noHistory: "Aucune réservation pour l'instant",
    statsHint: "Enregistre ton numéro ci-dessus pour retrouver tes rendez-vous et tes statistiques.",
  },
  en: {
    slogan: "Get the style you deserve",
    googleLogin: "Sign in with Google",
    googleLoginShort: "Sign in with Google",
    errGoogle: "Google sign-in is unavailable right now.",
    guest: "Continue as guest",
    pro: "Pro area",
    shopSub: "Barber Shop · Meyrin",
    book: "Book", bookSub: "Pick your service and time slot", bookCta: "Book now",
    myRdv: "My bookings", myRdvSub: "Manage my booking",
    profile: "Profile", profileSub: "My account",
    place: "Location", placeSub: "Meyrin, Geneva", socials: "Socials",
    guestMode: "Guest mode",
    myNumber: "My number · used for my bookings",
    numberSaved: "✓ Number saved — pre-filled at every booking",
    nextRdv: "My next appointment", manageRdv: "Manage my bookings",
    visit: "Visit", visits: "Visits",
    usualCut: "My usual cut", rebook: "Book again",
    review: "⭐ Leave a review", call: "📞 Call", wa: "💬 WhatsApp",
    logout: "Log out",
    settings: "Settings",
    photoLbl: "Profile photo", changePhoto: "Change", removePhoto: "Remove",
    language: "Language", themeLbl: "Theme", darkLbl: "Dark", lightLbl: "Light",
    bkTitle1: "My", bkTitle2: "appointments",
    findSub: "Find your bookings with your phone number",
    loadingTxt: "Loading…",
    none: "No booking found for this number.",
    cancelRdv: "Cancel this booking",
    cancelWarn: "⚠️ Cancel at least 24h in advance. No-shows are charged 50% of the price.",
    confirm: "Confirm", keep: "Keep", cancelling: "Cancelling…",
    orDivider: "or",
    emailOption: "Continue with email",
    loginTitle: "Sign in", signupTitle: "Create account",
    nameLbl: "Full name", emailLbl: "Email address", pwdLbl: "Password (min. 6 characters)",
    loginBtn: "Sign in", signupBtn: "Create my account",
    toSignup: "No account yet? Create one", toLogin: "Already have an account? Sign in",
    checkEmail: "Account created! Check your inbox to confirm your address, then sign in.",
    errAuth: "Incorrect email or password.",
    errSignup: "Could not create the account. Try again.",
    errFields: "Enter a valid email and a password of at least 6 characters.",
    backLbl: "← Back",
    orEmailProfile: "or create an account with email",
    noUpcoming: "No upcoming appointment",
    noHistory: "No booking yet",
    statsHint: "Save your number above to see your appointments and stats.",
  },
};

// date stockée en "Vendredi 10.07.2026" OU "Samedi 2.05.2026" (jour sur 1 chiffre) → Date JS
function parseRdvDate(dateStr, heure) {
  const m = (dateStr || "").match(/(\d{1,2})\.(\d{1,2})\.(\d{4})/);
  if (!m) return null;
  const [h, min] = (heure || "0:0").split(":").map(Number);
  return new Date(Number(m[3]), Number(m[2]) - 1, Number(m[1]), h || 0, min || 0);
}

function HomeScreen({ onNavigate, onPro, t }) {
  const icon = (paths, size = 20) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="var(--gold)" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">{paths}</svg>
  );
  const icons = {
    rdv: icon(<><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/><path d="M9 15l2 2 4-4"/></>),
    profil: icon(<><circle cx="12" cy="8" r="4"/><path d="M4 21c0-4 3.6-6.5 8-6.5s8 2.5 8 6.5"/></>),
    lieu: icon(<><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 1 1 16 0z"/><circle cx="12" cy="10" r="3"/></>),
    insta: icon(<><rect x="2" y="2" width="20" height="20" rx="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.5" cy="6.5" r="1" fill="var(--gold)" stroke="none"/></>),
  };

  const tiles = [
    { key: 'rdv', label: t.myRdv, sub: t.myRdvSub, action: () => onNavigate('rdv') },
    { key: 'profil', label: t.profile, sub: t.profileSub, action: () => onNavigate('profile') },
    { key: 'lieu', label: t.place, sub: t.placeSub, action: () => window.open(MAPS_URL, '_blank') },
    { key: 'insta', label: t.socials, sub: '@mendescut.barbershop', action: () => window.open(INSTA_URL, '_blank') },
  ];

  return (
    <div className="home-wrap" style={{
      background: 'var(--bg)', display: 'flex', flexDirection: 'column', overflow: 'hidden',
      padding: 'calc(14px + env(safe-area-inset-top)) 18px calc(14px + env(safe-area-inset-bottom))',
      fontFamily: "'Lato',sans-serif", maxWidth: 520, margin: '0 auto', boxSizing: 'border-box',
    }}>
      <style>{`.home-wrap{height:100vh;height:100dvh;}`}</style>
      <div style={{ textAlign: 'center', marginBottom: 12, flexShrink: 0 }}>
        <div style={{ fontFamily: "'Bebas Neue',sans-serif", fontSize: 26, letterSpacing: '0.1em', color: 'var(--text)' }}>
          MENDES <span style={{ color: 'var(--gold)' }}>✂</span> CUT
        </div>
        <div style={{ fontSize: 9, letterSpacing: '0.3em', color: 'var(--muted)', textTransform: 'uppercase', marginTop: 2 }}>
          {t.shopSub}
        </div>
      </div>

      <button onClick={() => onNavigate('booking')} style={{
        flex: '1 1 auto', minHeight: 0, width: '100%', marginBottom: 12,
        background: 'linear-gradient(160deg, var(--card) 0%, var(--card2) 100%)',
        border: '1px solid var(--gold-a35)', borderRadius: 12, cursor: 'pointer',
        display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 14,
      }}>
        <svg width="52" height="52" viewBox="0 0 24 24" fill="none" stroke="var(--gold)" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round">
          <rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/>
          <circle cx="12" cy="16" r="0.5" fill="var(--gold)"/>
        </svg>
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontFamily: "'Bebas Neue',sans-serif", fontSize: 24, letterSpacing: '0.12em', color: 'var(--text)', marginBottom: 3 }}>{t.book}</div>
          <div style={{ fontSize: 11, color: 'var(--muted)' }}>{t.bookSub}</div>
        </div>
        <div style={{
          padding: '11px 30px', background: 'var(--gold)', borderRadius: 6, color: 'var(--on-gold)',
          fontFamily: "'Bebas Neue',sans-serif", fontSize: 15, letterSpacing: '0.22em',
        }}>
          {t.bookCta}
        </div>
      </button>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, flexShrink: 0 }}>
        {tiles.map((tile) => (
          <button key={tile.key} onClick={tile.action} style={{
            background: 'var(--card)', border: '1px solid var(--gold-a2)', borderRadius: 12,
            padding: '13px 14px', cursor: 'pointer', textAlign: 'left',
            display: 'flex', flexDirection: 'column', gap: 7,
          }}>
            {icons[tile.key]}
            <div>
              <div style={{ fontFamily: "'Bebas Neue',sans-serif", fontSize: 15, letterSpacing: '0.1em', color: 'var(--text)' }}>{tile.label}</div>
              <div style={{ fontSize: 9, color: 'var(--muted)', marginTop: 1 }}>{tile.sub}</div>
            </div>
          </button>
        ))}
      </div>

      {onPro && (
        <button onClick={onPro} style={{
          marginTop: 10, flexShrink: 0, background: 'none', border: 'none', color: 'var(--muted)',
          fontSize: 10, letterSpacing: '0.2em', textTransform: 'uppercase', cursor: 'pointer',
          fontFamily: "'Lato',sans-serif", textDecoration: 'underline',
          textUnderlineOffset: 4, textDecorationColor: 'var(--gold-a2)',
        }}>
          {t.pro}
        </button>
      )}
    </div>
  );
}

function BackButton({ onBack }) {
  return (
    <button onClick={onBack} style={{
      position: 'fixed', top: 'calc(14px + env(safe-area-inset-top))', left: 14, zIndex: 9000,
      width: 38, height: 38, borderRadius: '50%',
      background: 'var(--back-bg)', border: '1px solid var(--gold-a35)',
      color: 'var(--gold)', fontSize: 18, cursor: 'pointer',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
    }} aria-label="Retour à l'accueil">
      ←
    </button>
  );
}

function MyBookingsScreen({ t }) {
  const [countryCode, setCountryCode] = useState("+41");
  const [phone, setPhone] = useState("");
  const [bookings, setBookings] = useState(null); // null = pas encore cherché
  const [loading, setLoading] = useState(false);
  const [cancelling, setCancelling] = useState(null); // id en cours d'annulation
  const [confirmId, setConfirmId] = useState(null);

  useEffect(() => {
    const saved = lsGet("client-phone");
    if (saved) {
      const m = saved.match(/^(\+\d{2})(\d+)$/);
      if (m) { setCountryCode(m[1]); setPhone(m[2]); }
      search(saved);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function normalize() {
    return countryCode + phone.replace(/^0/, "").replace(/[\s\-.]/g, "");
  }

  async function search(fullPhone) {
    const tel = fullPhone || normalize();
    if (tel.length < 8) return;
    setLoading(true);
    const { data } = await supabase.rpc("reservations_par_telephone", { p_tel: tel });
    lsSet("client-phone", tel);
    setBookings(data || []);
    setLoading(false);
  }

  // true si aujourd'hui ou plus tard (jour/mois sur 1 ou 2 chiffres)
  function isUpcoming(dateStr) {
    const m = (dateStr || "").match(/(\d{1,2})\.(\d{1,2})\.(\d{4})/);
    if (!m) return false;
    const d = new Date(Number(m[3]), Number(m[2]) - 1, Number(m[1]), 23, 59);
    return d >= new Date();
  }

  async function cancelRdv(id) {
    setCancelling(id);
    try {
      const res = await fetch("https://mendescut-barbershop.com/api/cancel-rdv", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id }),
      });
      const data = await res.json();
      if (res.ok && data.success) {
        setBookings((prev) => prev.map((b) => (b.id === id ? { ...b, statut: "annulé" } : b)));
      }
    } catch (e) { console.error("Annulation échouée:", e); }
    setCancelling(null); setConfirmId(null);
  }

  const inputStyle = {
    background: 'var(--input)', border: '1px solid var(--gold-a35)', borderRadius: 4,
    padding: '13px 12px', color: 'var(--text)', fontFamily: "'Lato',sans-serif", fontSize: 14, outline: 'none',
  };

  return (
    <div style={{
      minHeight: '100vh', background: 'var(--bg)',
      padding: 'calc(70px + env(safe-area-inset-top)) 20px 40px',
      fontFamily: "'Lato',sans-serif", maxWidth: 460, margin: '0 auto',
    }}>
      <div style={{ textAlign: 'center', marginBottom: 24 }}>
        <div style={{ fontFamily: "'Bebas Neue',sans-serif", fontSize: 24, letterSpacing: '0.12em', color: 'var(--text)' }}>
          {t.bkTitle1} <span style={{ color: 'var(--gold)' }}>{t.bkTitle2}</span>
        </div>
        <div style={{ fontSize: 10, letterSpacing: '0.25em', color: 'var(--muted)', textTransform: 'uppercase', marginTop: 4 }}>
          {t.findSub}
        </div>
      </div>

      <div style={{ display: 'flex', gap: 8, marginBottom: 24 }}>
        <select value={countryCode} onChange={(e) => setCountryCode(e.target.value)} style={{ ...inputStyle, width: 86 }}>
          <option value="+41">🇨🇭 +41</option>
          <option value="+33">🇫🇷 +33</option>
        </select>
        <input
          type="tel" placeholder="79 123 45 67" value={phone}
          onChange={(e) => setPhone(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && search()}
          style={{ ...inputStyle, flex: 1 }}
        />
        <button onClick={() => search()} disabled={loading} style={{
          padding: '0 18px', background: 'var(--gold)', border: 'none', borderRadius: 4,
          color: 'var(--on-gold)', fontFamily: "'Bebas Neue',sans-serif", fontSize: 14, letterSpacing: '0.1em',
          cursor: 'pointer', opacity: loading ? 0.6 : 1,
        }}>
          OK
        </button>
      </div>

      {loading && <div style={{ textAlign: 'center', color: 'var(--muted)', fontSize: 13 }}>{t.loadingTxt}</div>}

      {!loading && bookings && bookings.length === 0 && (
        <div style={{ textAlign: 'center', color: 'var(--muted)', fontSize: 13, padding: '30px 0' }}>
          {t.none}
        </div>
      )}

      {!loading && bookings && bookings.map((b) => {
        const upcoming = isUpcoming(b.date) && b.statut === "confirmé";
        return (
          <div key={b.id} style={{
            background: 'var(--card)', border: '1px solid var(--gold-a2)', borderRadius: 10,
            padding: '16px 18px', marginBottom: 12, opacity: b.statut === "annulé" ? 0.55 : 1,
          }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', marginBottom: 8 }}>
              <div style={{ fontFamily: "'Bebas Neue',sans-serif", fontSize: 17, letterSpacing: '0.08em', color: 'var(--gold)' }}>{b.service}</div>
              <div style={{
                fontSize: 9, letterSpacing: '0.15em', textTransform: 'uppercase', padding: '3px 8px', borderRadius: 3,
                background: b.statut === "confirmé" ? 'rgba(120,180,120,0.12)' : 'rgba(200,80,80,0.12)',
                color: b.statut === "confirmé" ? 'var(--ok)' : 'var(--danger)',
              }}>{b.statut}</div>
            </div>
            <div style={{ fontSize: 13, color: 'var(--text)', marginBottom: 2 }}>{b.date} · {b.heure}</div>
            {b.supplements && <div style={{ fontSize: 11, color: 'var(--muted)', marginBottom: 2 }}>+ {b.supplements}</div>}
            <div style={{ fontSize: 12, color: 'var(--muted)' }}>{b.total} CHF</div>

            {upcoming && confirmId !== b.id && (
              <button onClick={() => setConfirmId(b.id)} style={{
                marginTop: 12, width: '100%', padding: '10px', background: 'transparent',
                border: '1px solid var(--danger)', borderRadius: 4, color: 'var(--danger)',
                fontFamily: "'Lato',sans-serif", fontSize: 11, letterSpacing: '0.15em',
                textTransform: 'uppercase', cursor: 'pointer',
              }}>
                {t.cancelRdv}
              </button>
            )}
            {upcoming && confirmId === b.id && (
              <div style={{ marginTop: 12 }}>
                <div style={{ fontSize: 11, color: 'var(--danger)', lineHeight: 1.5, marginBottom: 10 }}>
                  {t.cancelWarn}
                </div>
                <div style={{ display: 'flex', gap: 8 }}>
                  <button onClick={() => cancelRdv(b.id)} disabled={cancelling === b.id} style={{
                    flex: 1, padding: '10px', background: 'var(--danger)', border: 'none', borderRadius: 4,
                    color: '#FFFFFF', fontWeight: 700, fontSize: 12, cursor: 'pointer',
                    opacity: cancelling === b.id ? 0.6 : 1,
                  }}>
                    {cancelling === b.id ? t.cancelling : t.confirm}
                  </button>
                  <button onClick={() => setConfirmId(null)} style={{
                    flex: 1, padding: '10px', background: 'transparent',
                    border: '1px solid var(--gold-a35)', borderRadius: 4, color: 'var(--muted)',
                    fontSize: 12, cursor: 'pointer',
                  }}>
                    {t.keep}
                  </button>
                </div>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}

function SettingsButton({ onOpen }) {
  return (
    <button onClick={onOpen} style={{
      position: 'fixed', top: 'calc(14px + env(safe-area-inset-top))', right: 14, zIndex: 9000,
      width: 38, height: 38, borderRadius: '50%',
      background: 'var(--back-bg)', border: '1px solid var(--gold-a35)',
      color: 'var(--gold)', fontSize: 17, cursor: 'pointer',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
    }} aria-label="Paramètres">
      ⚙
    </button>
  );
}

function SettingsScreen({ t, lang, setLang, theme, setTheme }) {
  const [photo, setPhoto] = useState(() => lsGet("profile-photo"));

  // Photo choisie → recadrée en carré 240px → base64 en local
  function handlePhotoFile(e) {
    const file = e.target.files?.[0];
    if (!file) return;
    const img = new Image();
    img.onload = () => {
      const size = 240;
      const canvas = document.createElement('canvas');
      canvas.width = size; canvas.height = size;
      const ctx = canvas.getContext('2d');
      const s = Math.min(img.width, img.height);
      ctx.drawImage(img, (img.width - s) / 2, (img.height - s) / 2, s, s, 0, 0, size, size);
      const dataUrl = canvas.toDataURL('image/jpeg', 0.85);
      lsSet("profile-photo", dataUrl);
      setPhoto(dataUrl);
      URL.revokeObjectURL(img.src);
    };
    img.src = URL.createObjectURL(file);
    e.target.value = "";
  }

  function removePhoto() {
    lsDel("profile-photo");
    setPhoto(null);
  }

  const card = {
    background: 'var(--card)', border: '1px solid var(--gold-a2)',
    borderRadius: 12, padding: '18px 20px', marginBottom: 14,
  };
  const ghostBtn = {
    padding: '9px 14px', background: 'transparent',
    border: '1px solid var(--gold-a35)', borderRadius: 6, color: 'var(--gold)',
    fontFamily: "'Lato',sans-serif", fontSize: 11, letterSpacing: '0.08em', cursor: 'pointer',
  };
  const chip = (active) => ({
    flex: 1, padding: '10px 8px', borderRadius: 6, cursor: 'pointer',
    fontFamily: "'Lato',sans-serif", fontSize: 11, letterSpacing: '0.08em',
    background: active ? 'var(--gold)' : 'transparent',
    border: active ? '1px solid var(--gold)' : '1px solid var(--gold-a35)',
    color: active ? 'var(--on-gold)' : 'var(--muted)',
    fontWeight: active ? 700 : 400,
  });

  return (
    <div style={{
      minHeight: '100vh', background: 'var(--bg)',
      padding: 'calc(70px + env(safe-area-inset-top)) 20px calc(40px + env(safe-area-inset-bottom))',
      fontFamily: "'Lato',sans-serif", maxWidth: 460, margin: '0 auto',
    }}>
      <div style={{ textAlign: 'center', marginBottom: 24 }}>
        <div style={{ fontFamily: "'Bebas Neue',sans-serif", fontSize: 24, letterSpacing: '0.12em', color: 'var(--text)' }}>
          ⚙ <span style={{ color: 'var(--gold)' }}>{t.settings}</span>
        </div>
      </div>

      <div style={card}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 10, marginBottom: 18 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            {photo && <img src={photo} alt="" style={{ width: 34, height: 34, borderRadius: '50%', objectFit: 'cover', border: '1px solid var(--gold-a5)' }} />}
            <div style={{ fontSize: 12, color: 'var(--text)' }}>{t.photoLbl}</div>
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            <label style={ghostBtn}>
              {t.changePhoto}
              <input type="file" accept="image/*" onChange={handlePhotoFile} style={{ display: 'none' }} />
            </label>
            {photo && (
              <button onClick={removePhoto} style={{ ...ghostBtn, color: 'var(--danger)', borderColor: 'var(--danger)' }}>
                {t.removePhoto}
              </button>
            )}
          </div>
        </div>

        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 10, marginBottom: 18 }}>
          <div style={{ fontSize: 12, color: 'var(--text)' }}>{t.language}</div>
          <div style={{ display: 'flex', gap: 8, width: 160 }}>
            <button onClick={() => setLang('fr')} style={chip(lang === 'fr')}>FR</button>
            <button onClick={() => setLang('en')} style={chip(lang === 'en')}>EN</button>
          </div>
        </div>

        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 10 }}>
          <div style={{ fontSize: 12, color: 'var(--text)' }}>{t.themeLbl}</div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <span style={{ fontSize: 11, color: 'var(--muted)' }}>
              {theme === 'light' ? t.lightLbl : t.darkLbl}
            </span>
            <button
              onClick={() => setTheme(theme === 'light' ? 'dark' : 'light')}
              aria-label={t.themeLbl}
              style={{
                position: 'relative', width: 62, height: 32, borderRadius: 99, cursor: 'pointer',
                border: '1px solid var(--gold-a35)', padding: 0,
                background: theme === 'light' ? 'var(--gold)' : 'var(--input)',
                transition: 'background 0.25s ease',
              }}
            >
              <span style={{
                position: 'absolute', top: 3, left: theme === 'light' ? 32 : 3,
                width: 24, height: 24, borderRadius: '50%',
                background: theme === 'light' ? '#FFFFFF' : '#4A443C',
                display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 12,
                transition: 'left 0.25s cubic-bezier(0.4, 0, 0.2, 1)',
                boxShadow: '0 1px 3px rgba(0,0,0,0.35)',
              }}>
                {theme === 'light' ? '☀️' : '🌙'}
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

function ProfileScreen({ session, onBack, onNavigate, onEmailAuth, t }) {
  const [busy, setBusy] = useState(false);
  const [countryCode, setCountryCode] = useState("+41");
  const [phone, setPhone] = useState("");
  const [savedTel, setSavedTel] = useState(null);
  const [stats, setStats] = useState(null); // { next, visits, favorite }
  const [photo] = useState(() => lsGet("profile-photo")); // gérée depuis la page Paramètres
  const user = session?.user;
  const name = user?.user_metadata?.full_name || user?.user_metadata?.name || "";
  const email = user?.email || "";
  const avatar = photo || user?.user_metadata?.avatar_url || "";
  const initial = (name || email || "?").charAt(0).toUpperCase();

  useEffect(() => {
    const saved = lsGet("client-phone");
    if (saved) {
      const m = saved.match(/^(\+\d{2})(\d+)$/);
      if (m) { setCountryCode(m[1]); setPhone(m[2]); }
      setSavedTel(saved);
      loadStats(saved);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function loadStats(tel) {
    const { data } = await supabase.rpc("reservations_par_telephone", { p_tel: tel });
    const all = data || [];
    const rows = all.filter((r) => r.statut !== "annulé");
    const now = new Date();
    const dated = rows.map((r) => ({ ...r, _d: parseRdvDate(r.date, r.heure) })).filter((r) => r._d);
    const upcoming = dated.filter((r) => r._d >= now && r.statut === "confirmé").sort((a, b) => a._d - b._d);
    // Coupe habituelle : d'abord les RDV honorés, sinon tout l'historique (même annulé)
    const counts = {};
    (rows.length ? rows : all).forEach((r) => { counts[r.service] = (counts[r.service] || 0) + 1; });
    const favorite = Object.entries(counts).sort((a, b) => b[1] - a[1])[0]?.[0] || null;
    setStats({
      next: upcoming[0] || null,
      visits: dated.filter((r) => r._d < now).length,
      favorite,
    });
  }

  function savePhone() {
    const tel = countryCode + phone.replace(/^0/, "").replace(/[\s\-.]/g, "");
    if (tel.length < 8) return;
    lsSet("client-phone", tel);
    setSavedTel(tel);
    loadStats(tel);
  }

  function rebook() {
    if (stats?.favorite) lsSet("preselect-service", stats.favorite);
    onNavigate('booking');
  }

  async function logout() {
    setBusy(true);
    await supabase.auth.signOut();
    setBusy(false);
    onBack();
  }

  async function loginGoogle() {
    setBusy(true);
    await signInWithGoogle();
    setBusy(false);
  }

  const card = {
    background: 'var(--card)', border: '1px solid var(--gold-a2)',
    borderRadius: 12, padding: '13px 16px', marginBottom: 10,
  };
  const label = {
    fontSize: 9, letterSpacing: '0.25em', color: 'var(--muted)',
    textTransform: 'uppercase', marginBottom: 8,
  };
  const inputStyle = {
    background: 'var(--input)', border: '1px solid var(--gold-a35)', borderRadius: 4,
    padding: '10px 10px', color: 'var(--text)', fontFamily: "'Lato',sans-serif", fontSize: 13, outline: 'none',
  };
  const ghostBtn = {
    flex: 1, padding: '11px 8px', background: 'transparent',
    border: '1px solid var(--gold-a35)', borderRadius: 6, color: 'var(--gold)',
    fontFamily: "'Lato',sans-serif", fontSize: 11, letterSpacing: '0.08em', cursor: 'pointer',
  };

  return (
    <div style={{
      minHeight: '100vh', background: 'var(--bg)',
      padding: 'calc(58px + env(safe-area-inset-top)) 18px calc(18px + env(safe-area-inset-bottom))',
      fontFamily: "'Lato',sans-serif", maxWidth: 460, margin: '0 auto', boxSizing: 'border-box',
    }}>
      {/* Identité */}
      <div style={{ ...card, textAlign: 'center', padding: '16px' }}>
        {avatar ? (
          <img src={avatar} alt="" referrerPolicy="no-referrer" style={{ width: 54, height: 54, borderRadius: '50%', border: '2px solid var(--gold-a5)', marginBottom: 8, objectFit: 'cover' }} />
        ) : (
          <div style={{
            width: 54, height: 54, borderRadius: '50%', margin: '0 auto 8px',
            background: 'rgba(200,169,110,0.12)', border: '2px solid var(--gold-a5)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontFamily: "'Bebas Neue',sans-serif", fontSize: 22, color: 'var(--gold)',
          }}>{user ? initial : '✂'}</div>
        )}
        {user ? (
          <>
            {name && <div style={{ fontSize: 16, fontWeight: 700, color: 'var(--text)', marginBottom: 2 }}>{name}</div>}
            <div style={{ fontSize: 12, color: 'var(--muted)' }}>{email}</div>
          </>
        ) : (
          <>
            <div style={{ fontSize: 14, fontWeight: 700, color: 'var(--text)', marginBottom: 10 }}>{t.guestMode}</div>
            <button onClick={loginGoogle} disabled={busy} style={{
              display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 8,
              padding: '11px 20px', background: 'var(--btnc-bg)', border: '1px solid var(--btnc-border)', borderRadius: 6,
              color: '#201E1A', fontWeight: 700, fontSize: 12, cursor: 'pointer',
              fontFamily: "'Lato',sans-serif", opacity: busy ? 0.6 : 1,
            }}>
              <svg width="14" height="14" viewBox="0 0 48 48">
                <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
                <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
                <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
                <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
              </svg>
              {t.googleLoginShort}
            </button>
            <button onClick={onEmailAuth} style={{
              display: 'block', margin: '10px auto 0', background: 'none', border: 'none',
              color: 'var(--gold)', fontSize: 11, cursor: 'pointer', fontFamily: "'Lato',sans-serif",
              textDecoration: 'underline', textUnderlineOffset: 3,
            }}>
              {t.orEmailProfile}
            </button>
          </>
        )}
      </div>

      {/* Numéro de téléphone */}
      <div style={card}>
        <div style={label}>{t.myNumber}</div>
        <div style={{ display: 'flex', gap: 8 }}>
          <select value={countryCode} onChange={(e) => setCountryCode(e.target.value)} style={{ ...inputStyle, width: 82 }}>
            <option value="+41">🇨🇭 +41</option>
            <option value="+33">🇫🇷 +33</option>
          </select>
          <input
            type="tel" placeholder="79 123 45 67" value={phone}
            onChange={(e) => setPhone(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && savePhone()}
            style={{ ...inputStyle, flex: 1 }}
          />
          <button onClick={savePhone} style={{
            padding: '0 16px', background: 'var(--gold)', border: 'none', borderRadius: 4,
            color: 'var(--on-gold)', fontFamily: "'Bebas Neue',sans-serif", fontSize: 13,
            letterSpacing: '0.1em', cursor: 'pointer',
          }}>
            OK
          </button>
        </div>
        {savedTel && <div style={{ fontSize: 10, color: 'var(--ok)', marginTop: 8 }}>{t.numberSaved}</div>}
      </div>

      {/* Prochain RDV — toujours affiché quand le numéro est enregistré */}
      {stats ? (
        <div style={{ ...card, border: '1px solid var(--gold-a5)' }}>
          <div style={label}>{t.nextRdv}</div>
          {stats.next ? (
            <>
              <div style={{ fontFamily: "'Bebas Neue',sans-serif", fontSize: 18, letterSpacing: '0.08em', color: 'var(--gold)', marginBottom: 4 }}>
                {stats.next.service}
              </div>
              <div style={{ fontSize: 13, color: 'var(--text)', marginBottom: 12 }}>{stats.next.date} · {stats.next.heure}</div>
              <button onClick={() => onNavigate('rdv')} style={{ ...ghostBtn, width: '100%' }}>
                {t.manageRdv}
              </button>
            </>
          ) : (
            <>
              <div style={{ fontSize: 13, color: 'var(--muted)', marginBottom: 12 }}>{t.noUpcoming}</div>
              <button onClick={() => onNavigate('booking')} style={{
                width: '100%', padding: '11px', background: 'var(--gold)', border: 'none', borderRadius: 6,
                color: 'var(--on-gold)', fontFamily: "'Bebas Neue',sans-serif", fontSize: 14,
                letterSpacing: '0.18em', cursor: 'pointer',
              }}>
                {t.bookCta}
              </button>
            </>
          )}
        </div>
      ) : (
        <div style={card}>
          <div style={{ fontSize: 12, color: 'var(--muted)', lineHeight: 1.6 }}>{t.statsHint}</div>
        </div>
      )}

      {/* Stats + coupe habituelle — toujours affichées quand le numéro est enregistré */}
      {stats && (
        <div style={{ display: 'flex', gap: 10, marginBottom: 10 }}>
          <div style={{ ...card, flex: 1, marginBottom: 0, textAlign: 'center' }}>
            <div style={{ fontFamily: "'Bebas Neue',sans-serif", fontSize: 30, color: 'var(--gold)' }}>{stats.visits}</div>
            <div style={{ fontSize: 9, letterSpacing: '0.2em', color: 'var(--muted)', textTransform: 'uppercase' }}>
              {stats.visits > 1 ? t.visits : t.visit} ✂
            </div>
          </div>
          <div style={{ ...card, flex: 2, marginBottom: 0 }}>
            <div style={label}>{t.usualCut}</div>
            {stats.favorite ? (
              <>
                <div style={{ fontSize: 13, fontWeight: 700, color: 'var(--text)', marginBottom: 10 }}>{stats.favorite}</div>
                <button onClick={rebook} style={{
                  width: '100%', padding: '10px', background: 'var(--gold)', border: 'none', borderRadius: 6,
                  color: 'var(--on-gold)', fontFamily: "'Bebas Neue',sans-serif", fontSize: 13,
                  letterSpacing: '0.15em', cursor: 'pointer',
                }}>
                  {t.rebook}
                </button>
              </>
            ) : (
              <div style={{ fontSize: 12, color: 'var(--muted)' }}>{t.noHistory}</div>
            )}
          </div>
        </div>
      )}

      {/* Avis + contact */}
      <div style={{ display: 'flex', gap: 10, marginBottom: 10 }}>
        <button onClick={() => window.open(GOOGLE_REVIEW_URL, '_blank')} style={ghostBtn}>
          {t.review}
        </button>
        <button onClick={() => { window.location.href = `tel:${SHOP_PHONE}`; }} style={ghostBtn}>
          {t.call}
        </button>
        <button onClick={() => window.open(`https://wa.me/${SHOP_PHONE.replace('+', '')}`, '_blank')} style={ghostBtn}>
          {t.wa}
        </button>
      </div>

      {user && (
        <button onClick={logout} disabled={busy} style={{
          width: '100%', padding: '14px', background: 'transparent',
          border: '1px solid var(--danger)', borderRadius: 6, color: 'var(--danger)',
          fontFamily: "'Bebas Neue',sans-serif", fontSize: 14, letterSpacing: '0.2em',
          cursor: 'pointer', opacity: busy ? 0.6 : 1,
        }}>
          {t.logout}
        </button>
      )}
    </div>
  );
}

function PrivacyPage() {
  useEffect(() => {
    const link = document.createElement('link');
    link.href = 'https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Lato:wght@300;400;700&display=swap';
    link.rel = 'stylesheet';
    document.head.appendChild(link);
  }, []);

  const [activeTab, setActiveTab] = useState('cgu');

  const style = `
    *{box-sizing:border-box;margin:0;padding:0;}
    body{background:#201E1A;}
    .priv-header{background:#2B2925;border-bottom:1px solid rgba(200,169,110,0.3);padding:20px;text-align:center;}
    .priv-logo{font-family:'Bebas Neue',sans-serif;font-size:28px;letter-spacing:0.1em;color:#F0EAE0;}
    .priv-logo span{color:#C8A96E;}
    .priv-sub{font-size:10px;letter-spacing:0.3em;color:#7A7060;text-transform:uppercase;margin-top:4px;}
    .priv-nav{display:flex;justify-content:center;gap:8px;padding:16px;background:#2B2925;border-bottom:1px solid rgba(200,169,110,0.15);flex-wrap:wrap;}
    .priv-content{max-width:800px;margin:0 auto;padding:32px 20px 60px;font-family:'Lato',sans-serif;color:#F0EAE0;}
    .priv-doc-title{font-family:'Bebas Neue',sans-serif;font-size:32px;letter-spacing:0.08em;margin-bottom:6px;}
    .priv-doc-title span{color:#C8A96E;}
    .priv-date{font-size:11px;color:#7A7060;letter-spacing:0.15em;margin-bottom:32px;padding-bottom:16px;border-bottom:1px solid rgba(200,169,110,0.2);}
    .priv-h2{font-family:'Bebas Neue',sans-serif;font-size:18px;letter-spacing:0.08em;color:#C8A96E;margin:28px 0 12px;}
    .priv-p{font-size:13px;line-height:1.8;color:#C8C0B0;margin-bottom:14px;text-align:justify;}
    .priv-ul{margin:0 0 14px 20px;}
    .priv-li{font-size:13px;line-height:1.8;color:#C8C0B0;margin-bottom:4px;list-style-type:disc;}
    .priv-highlight{background:rgba(200,169,110,0.08);border:1px solid rgba(200,169,110,0.2);border-radius:4px;padding:14px 16px;margin-bottom:24px;font-size:13px;color:#D0CAC0;line-height:1.7;}
    .priv-footer{text-align:center;padding:24px;border-top:1px solid rgba(200,169,110,0.15);font-size:11px;color:#7A7060;letter-spacing:0.1em;margin-top:40px;}
  `;

  const navBtn = (id, label) => (
    <button onClick={() => setActiveTab(id)} style={{
      padding: '8px 16px', borderRadius: 20,
      fontFamily: "'Lato',sans-serif", fontSize: 11, letterSpacing: '0.1em',
      textTransform: 'uppercase', cursor: 'pointer', transition: 'all 0.2s',
      border: '1px solid rgba(200,169,110,0.3)',
      background: activeTab === id ? 'rgba(200,169,110,0.15)' : 'transparent',
      borderColor: activeTab === id ? '#C8A96E' : 'rgba(200,169,110,0.3)',
      color: activeTab === id ? '#C8A96E' : '#7A7060',
    }}>{label}</button>
  );

  return (
    <div style={{ background: '#201E1A', minHeight: '100vh' }}>
      <style>{style}</style>

      <div className="priv-header">
        <div className="priv-logo">MENDES <span>✂</span> CUT</div>
        <div className="priv-sub">Barber Shop · Meyrin · Genève</div>
      </div>

      <div className="priv-nav">
        {navBtn('cgu', 'CGU')}
        {navBtn('privacy', 'Confidentialité')}
        {navBtn('ip', 'Propriété intellectuelle')}
      </div>

      <div className="priv-content">

        {activeTab === 'cgu' && <>
          <div className="priv-doc-title">Conditions Générales <span>d'Utilisation</span></div>
          <div className="priv-date">Dernière mise à jour : avril 2026 — Risky DEV pour Mendes Cut Barber Shop</div>
          <div className="priv-highlight">L'utilisation de l'application Mendes Cut implique l'acceptation pleine et entière des présentes conditions.</div>
          <div className="priv-h2">1. Présentation de l'application</div>
          <p className="priv-p">L'application Mendes Cut est éditée par <strong>Risky DEV</strong> (moussa.risky@gmail.com), pour le compte de <strong>Mendes Cut Barber Shop</strong>, situé au 60 avenue de Vaudagne, 1217 Meyrin, Genève, Suisse.</p>
          <p className="priv-p">L'Application permet aux utilisateurs de réserver des prestations de coiffure et de barbier en ligne, de consulter les tarifs et disponibilités, et de recevoir des confirmations par SMS.</p>
          <div className="priv-h2">2. Réservation en ligne</div>
          <ul className="priv-ul">
            <li className="priv-li">La réservation est confirmée uniquement après réception d'un SMS de confirmation.</li>
            <li className="priv-li">Toute réservation engage l'utilisateur à se présenter à l'heure convenue.</li>
            <li className="priv-li">En cas d'absence non signalée, <strong>50% du montant</strong> de la prestation sera facturé.</li>
            <li className="priv-li">Toute annulation doit être effectuée au minimum <strong>24 heures à l'avance</strong> via le lien reçu par SMS.</li>
            <li className="priv-li">Les créneaux horaires sont proposés à titre indicatif et peuvent être modifiés par le salon.</li>
          </ul>
          <div className="priv-h2">3. Tarifs et paiement</div>
          <p className="priv-p">Les tarifs sont indiqués en francs suisses (CHF). Les modes de paiement acceptés sont les <strong>espèces et Twint</strong>. Le paiement par carte bancaire n'est pas accepté.</p>
          <div className="priv-h2">4. Responsabilités</div>
          <p className="priv-p">Risky DEV et Mendes Cut Barber Shop ne sauraient être tenus responsables en cas de dysfonctionnement lié à une interruption du réseau, une panne des serveurs ou toute cause extérieure.</p>
          <div className="priv-h2">5. Droit applicable</div>
          <p className="priv-p">Les présentes conditions sont régies par le <strong>droit suisse</strong>. Tout litige sera soumis à la juridiction compétente du canton de Genève, Suisse.</p>
        </>}

        {activeTab === 'privacy' && <>
          <div className="priv-doc-title">Politique de <span>Confidentialité</span></div>
          <div className="priv-date">Dernière mise à jour : avril 2026 — Conforme LPD suisse et RGPD</div>
          <div className="priv-highlight">Nous collectons uniquement les données nécessaires à la gestion de vos réservations. Aucune donnée n'est vendue à des tiers.</div>
          <div className="priv-h2">1. Responsable du traitement</div>
          <p className="priv-p"><strong>Risky DEV</strong> — moussa.risky@gmail.com, pour le compte de Mendes Cut Barber Shop, 60 avenue de Vaudagne, 1217 Meyrin, Genève, Suisse.</p>
          <div className="priv-h2">2. Données collectées</div>
          <ul className="priv-ul">
            <li className="priv-li">Prénom et nom de famille</li>
            <li className="priv-li">Numéro de téléphone mobile</li>
            <li className="priv-li">Service(s) réservé(s) et suppléments choisis</li>
            <li className="priv-li">Date et heure du rendez-vous</li>
            <li className="priv-li">Montant total de la prestation</li>
            <li className="priv-li">Statut de la réservation (confirmé, annulé, terminé)</li>
          </ul>
          <p className="priv-p">Aucune donnée bancaire, mot de passe ou document d'identité n'est collecté.</p>
          <div className="priv-h2">3. Finalités du traitement</div>
          <ul className="priv-ul">
            <li className="priv-li">Gestion et confirmation des réservations en ligne</li>
            <li className="priv-li">Envoi de SMS de confirmation et de rappel de rendez-vous</li>
            <li className="priv-li">Notification au salon en cas de nouvelle réservation ou d'annulation</li>
            <li className="priv-li">Envoi d'une demande d'avis Google après la prestation</li>
            <li className="priv-li">Statistiques internes (nombre de RDV, chiffre d'affaires)</li>
          </ul>
          <div className="priv-h2">4. Sous-traitants techniques</div>
          <p className="priv-p">Vos données sont traitées par des prestataires techniques tiers basés en Europe, dans le strict cadre de la gestion des réservations. Ces prestataires sont soumis à des obligations de confidentialité et ne sont pas autorisés à utiliser vos données à d'autres fins. Aucune donnée n'est transmise en dehors de l'Espace Économique Européen.</p>
          <div className="priv-h2">5. Durée de conservation</div>
          <p className="priv-p">Les données sont conservées pendant <strong>12 mois</strong> à compter de la date du rendez-vous, puis supprimées. Elles peuvent être supprimées à tout moment sur demande.</p>
          <div className="priv-h2">6. Vos droits</div>
          <p className="priv-p">Conformément à la LPD suisse et au RGPD, vous disposez des droits d'accès, de rectification, d'effacement, de limitation, de portabilité et d'opposition. Contact : <strong>moussa.risky@gmail.com</strong>. Réponse sous 30 jours.</p>
          <div className="priv-h2">7. Cookies</div>
          <p className="priv-p">L'Application n'utilise pas de cookies de traçage ou publicitaires. Seul un identifiant local (localStorage) est utilisé pour mémoriser vos préférences d'affichage.</p>
        </>}

        {activeTab === 'ip' && <>
          <div className="priv-doc-title">Propriété <span>Intellectuelle</span></div>
          <div className="priv-date">Dernière mise à jour : avril 2026 — Risky DEV</div>
          <div className="priv-highlight">Le code source de l'Application appartient à Risky DEV. La marque et le logo Mendes Cut appartiennent à Mendes Cut Barber Shop.</div>
          <div className="priv-h2">1. Titularité des droits</div>
          <p className="priv-p">L'application Mendes Cut est une oeuvre originale développée et détenue par <strong>Risky DEV</strong> (Moussa MOUSSA — moussa.risky@gmail.com), développée pour le compte de Mendes Cut Barber Shop.</p>
          <div className="priv-h2">2. Droits de Risky DEV</div>
          <ul className="priv-ul">
            <li className="priv-li">Code source complet (frontend React, API Vercel, fonctions serverless)</li>
            <li className="priv-li">Architecture technique et design de l'Application</li>
            <li className="priv-li">Système de réservation en ligne et ses algorithmes</li>
            <li className="priv-li">Documentation technique associée</li>
          </ul>
          <div className="priv-h2">3. Droits de Mendes Cut Barber Shop</div>
          <ul className="priv-ul">
            <li className="priv-li">Nom commercial "Mendes Cut Barber Shop"</li>
            <li className="priv-li">Logo et charte graphique (typographie, couleurs, symbole ciseaux)</li>
            <li className="priv-li">Slogan "Obtiens le style que tu mérites"</li>
            <li className="priv-li">Données clients collectées via l'Application</li>
          </ul>
          <div className="priv-h2">4. Interdictions</div>
          <ul className="priv-ul">
            <li className="priv-li">Copier ou distribuer le code source de l'Application</li>
            <li className="priv-li">Effectuer une ingénierie inverse de l'Application</li>
            <li className="priv-li">Utiliser les éléments de marque Mendes Cut sans autorisation</li>
            <li className="priv-li">Exploiter les données clients à des fins non autorisées</li>
          </ul>
          <div className="priv-h2">5. Droit applicable</div>
          <p className="priv-p">Ces dispositions sont régies par le <strong>droit suisse</strong> (LDA et LPM). Tout litige sera soumis à la juridiction du canton de Genève.</p>
        </>}

        <div className="priv-footer">
          &copy; 2026 Risky DEV — Développé pour Mendes Cut Barber Shop · Meyrin, Genève, Suisse<br/>
          moussa.risky@gmail.com
        </div>
      </div>
    </div>
  );
}

export default function App() {
  const path = window.location.pathname;
  const [installPrompt, setInstallPrompt] = useState(null);
  const [showBanner, setShowBanner] = useState(false);
  const [splash, setSplash] = useState({ show: path === "/", fading: false });
  const [session, setSession] = useState(null);
  const [guest, setGuest] = useState(() => lsGet("guest-mode") === "true");
  const [lang, setLangState] = useState(() => lsGet("app-lang") || "fr");
  const [theme, setThemeState] = useState(() => lsGet("app-theme") || "dark");
  const setLang = (v) => { setLangState(v); lsSet("app-lang", v); };
  const setTheme = (v) => { setThemeState(v); lsSet("app-theme", v); };
  const t = T[lang] || T.fr;
  const dk = theme !== 'light';

  // Propage le thème au flow de réservation (MendesCut.jsx lit :root[data-theme])
  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
  }, [theme]);

  useEffect(() => {
    supabase.auth.getSession().then(({ data }) => setSession(data.session));
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, s) => setSession(s));
    return () => subscription.unsubscribe();
  }, []);

  // Deep link natif : retour OAuth mendescut://auth-callback?code=... → session
  useEffect(() => {
    const sub = CapApp.addListener('appUrlOpen', async ({ url }) => {
      if (!url || !url.includes('auth-callback')) return;
      Browser.close().catch(() => {});
      const code = new URL(url.replace('mendescut://', 'https://app/')).searchParams.get('code');
      if (code) {
        const { error } = await supabase.auth.exchangeCodeForSession(code);
        if (error) console.error('Échange code OAuth échoué:', error);
      }
    });
    return () => { sub.then((s) => s.remove()).catch(() => {}); };
  }, []);

  const enterAsGuest = () => {
    setGuest(true); // d'abord l'état — le stockage ne doit jamais bloquer l'entrée
    lsSet("guest-mode", "true");
  };

  const [screen, setScreen] = useState('home'); // home | booking | rdv | profile
  const goHome = () => setScreen('home');
  const [adminMode, setAdminMode] = useState(false); // Espace pro in-app
  const [authStart, setAuthStart] = useState('main'); // écran de connexion : main | email

  // Depuis le profil invité : quitter le mode invité pour créer un compte email
  const goEmailAuth = () => {
    setAuthStart('email');
    setScreen('home');
    setGuest(false);
    lsSet("guest-mode", "false");
  };
  const isInstalled =
    window.navigator.standalone === true ||
    window.matchMedia("(display-mode: standalone)").matches;

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (isInstalled) return;
    if (localStorage.getItem("pwa-dismissed")) return;
    window.addEventListener("beforeinstallprompt", (e) => {
      e.preventDefault();
      setInstallPrompt(e);
      setShowBanner(true);
    });
    const isIOS = /iphone|ipad|ipod/i.test(navigator.userAgent);
    const isSafari = /safari/i.test(navigator.userAgent) && !/chrome/i.test(navigator.userAgent);
    if (isIOS && isSafari) setShowBanner(true);
  }, []);

  useEffect(() => {
    if (path !== "/") return;
    const t1 = setTimeout(() => setSplash((s) => ({ ...s, fading: true })), 2000);
    const t2 = setTimeout(() => setSplash({ show: false, fading: false }), 2400);
    return () => { clearTimeout(t1); clearTimeout(t2); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleInstall = async () => {
    if (installPrompt) await installPrompt.prompt();
    localStorage.setItem("pwa-dismissed", "true");
    setShowBanner(false);
  };
  const handleDismiss = () => {
    localStorage.setItem("pwa-dismissed", "true");
    setShowBanner(false);
  };
  const isIOS = /iphone|ipad|ipod/i.test(navigator.userAgent);
  if (path === "/admin") return <AdminPanel />;
  if (path === "/cancel") return <CancelPage />;
  if (path === "/privacy") return <PrivacyPage />;
  if (adminMode) {
    return (
      <>
        {/* L'admin reste en thème sombre — variables minimales pour le bouton retour */}
        <style>{`:root{--back-bg:rgba(43,41,37,0.92);--gold:#C8A96E;--gold-a35:rgba(200,169,110,0.35);}`}</style>
        {/* Bande dédiée : encoche iOS + flèche retour, pour que l'en-tête admin ne soit pas recouvert */}
        <div style={{ paddingTop: 'calc(58px + env(safe-area-inset-top))', background: '#201E1A', minHeight: '100vh' }}>
          <AdminPanel />
        </div>
        <BackButton onBack={() => setAdminMode(false)} />
      </>
    );
  }
  return (
    <>
      <style>{`
        :root{
          --bg:${dk ? '#201E1A' : '#F4EFE7'};
          --card:${dk ? '#2B2925' : '#FFFFFF'};
          --card2:${dk ? '#26231F' : '#F7F3EC'};
          --input:${dk ? '#332F29' : '#F0EAE0'};
          --text:${dk ? '#F0EAE0' : '#2B2925'};
          --muted:${dk ? '#7A7060' : '#8A8070'};
          --gold:${dk ? '#C8A96E' : '#A8894E'};
          --on-gold:${dk ? '#201E1A' : '#FFFFFF'};
          --btnc-bg:${dk ? '#F0EAE0' : '#FFFFFF'};
          --btnc-border:${dk ? 'transparent' : 'rgba(0,0,0,0.15)'};
          --danger:${dk ? '#E07A5F' : '#B85C42'};
          --ok:${dk ? '#8FBF8F' : '#4E8F4E'};
          --gold-a2:${dk ? 'rgba(200,169,110,0.2)' : 'rgba(140,110,60,0.25)'};
          --gold-a35:${dk ? 'rgba(200,169,110,0.35)' : 'rgba(140,110,60,0.4)'};
          --gold-a5:${dk ? 'rgba(200,169,110,0.5)' : 'rgba(140,110,60,0.5)'};
          --back-bg:${dk ? 'rgba(43,41,37,0.92)' : 'rgba(255,255,255,0.92)'};
        }
        body{background:${dk ? '#201E1A' : '#F4EFE7'};}
      `}</style>
      {showBanner && (
        <div style={{
          position: "fixed", bottom: 0, left: 0, right: 0, zIndex: 9999,
          background: "#2B2925", borderTop: "1px solid #C8A96E",
          padding: "14px 20px", display: "flex", alignItems: "center",
          justifyContent: "space-between", gap: 12
        }}>
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <img src="/icons/icon-192.png" alt="logo" style={{ width: 40, height: 40, borderRadius: 10 }} />
            <div>
              <div style={{ color: "#F0EDE8", fontWeight: 700, fontSize: 14 }}>Mendes Cut</div>
              <div style={{ color: "#888", fontSize: 12 }}>
                {isIOS ? "Appuyez sur puis \"Sur l'écran d'accueil\"" : "Installer l'application"}
              </div>
            </div>
          </div>
          <div style={{ display: "flex", gap: 8 }}>
            {!isIOS && (
              <button onClick={handleInstall} style={{
                background: "#C8A96E", color: "#201E1A", border: "none",
                borderRadius: 8, padding: "8px 14px", fontWeight: 700,
                fontSize: 13, cursor: "pointer"
              }}>Installer</button>
            )}
            <button onClick={handleDismiss} style={{
              background: "transparent", color: "#888", border: "1px solid #444",
              borderRadius: 8, padding: "8px 10px", fontSize: 13, cursor: "pointer"
            }}>✕</button>
          </div>
        </div>
      )}
      {!(session || guest) && <AuthScreen key={authStart} initialMode={authStart} t={t} onGuest={enterAsGuest} onPro={() => setAdminMode(true)} />}
      {(session || guest) && screen === 'home' && (
        <HomeScreen
          t={t}
          onNavigate={setScreen}
          onPro={isAdminSession(session) ? () => setAdminMode(true) : undefined}
        />
      )}
      {(session || guest) && screen === 'booking' && <><MendesCut /><BackButton onBack={goHome} /></>}
      {(session || guest) && screen === 'rdv' && <><MyBookingsScreen t={t} /><BackButton onBack={goHome} /></>}
      {(session || guest) && screen === 'profile' && <><ProfileScreen session={session} onBack={goHome} onNavigate={setScreen} onEmailAuth={goEmailAuth} t={t} /><BackButton onBack={goHome} /><SettingsButton onOpen={() => setScreen('settings')} /></>}
      {(session || guest) && screen === 'settings' && <><SettingsScreen t={t} lang={lang} setLang={setLang} theme={theme} setTheme={setTheme} /><BackButton onBack={() => setScreen('profile')} /></>}
      {splash.show && <SplashScreen fading={splash.fading} />}
    </>
  );
}